import actions from '../actions';

const keyPrefix = 'nosturi:';

const parseState = string => {
  try {
    return JSON.parse(string);
  } catch (error) {
    console.error('Error restoring state', error);
    return undefined;
  }
};

const loadState = ({ key, storage }) => {
  const stateString = storage.getItem(keyPrefix + key);
  return stateString !== null ? parseState(stateString) : undefined;
};

const saveState = ({ key, storage }, state) => {
  try {
    const stateString = JSON.stringify(state);
    storage.setItem(keyPrefix + key, stateString);
  } catch (error) {
    console.error('Error persisting state', error);
  }
};

const persistReducer = ({ key, storage }, reducer) => (state, action) => {
  if (state === undefined) state = loadState({ key, storage });
  if (action.type === String(actions.reset) && action.meta.key === key)
    state = action.payload;
  return reducer(state, action);
};

const persistStoreKey = ({ key, storage }, store) => {
  let { [key]: oldValue } = store.getState();
  store.subscribe(() => {
    const { [key]: newValue } = store.getState();
    if (newValue === oldValue) return;
    saveState({ key, storage }, newValue);
    oldValue = newValue;
  });
};

const persistStore = ({ keys, storage }, store) => {
  for (const key of keys) persistStoreKey({ key, storage }, store);

  /*
  window.addEventListener('storage', event => {
    if (
      event.storageArea !== storage ||
      !event.key.startsWith(keyPrefix) ||
      event.newValue === event.oldValue
    )
      return;
    const key = event.key.substr(keyPrefix.length);
    const value = parseState(event.newValue);
    const action = actions.reset(key, value);
    store.dispatch({
      ...action,
      meta: { ...action.meta, local: true },
    });
  });
  */
};

export { persistReducer, persistStore };



// WEBPACK FOOTER //
// ./src/store/persist.js